import { render, staticRenderFns } from "./EmbedAuthStatus.vue?vue&type=template&id=655a8a04&scoped=true"
import script from "./EmbedAuthStatus.vue?vue&type=script&lang=js"
export * from "./EmbedAuthStatus.vue?vue&type=script&lang=js"
import style0 from "./EmbedAuthStatus.vue?vue&type=style&index=0&id=655a8a04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655a8a04",
  null
  
)

export default component.exports